module.exports = __webpack_public_path__ + "img/road-men.9cac49c0.png";